// tools function
import DOMPurify from "isomorphic-dompurify";
import { marked } from "marked";
export default {

  title(t) {
    if (!t) return 
    return t.charAt(0).toUpperCase() + t.slice(1);
  },

  limit(line, max) {
    return line.substring(0, max) + '...'
  },
  
  cut(line, max) {
    if (!line) return
    if (line.length <= max) return line
    return line.substring(0, max) + '...'
  },

  width(text, font = '16px sans-serif') {  
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');  
    context.font = font;    
    const metrics = context.measureText(text);
    return metrics.width + 'px';
},


  translit(text){
    var answer = '';
    var converter = {
      'а': 'a',    'б': 'b',    'в': 'v',    'г': 'g',    'д': 'd',
      'е': 'e',    'ё': 'e',    'ж': 'zh',   'з': 'z',    'и': 'i',
      'й': 'y',    'к': 'k',    'л': 'l',    'м': 'm',    'н': 'n',
      'о': 'o',    'п': 'p',    'р': 'r',    'с': 's',    'т': 't',
      'у': 'u',    'ф': 'f',    'х': 'h',    'ц': 'c',    'ч': 'ch',
      'ш': 'sh',   'щ': 'sch',  'ь': '',     'ы': 'y',    'ъ': '',
      'э': 'e',    'ю': 'yu',   'я': 'ya',
      'А': 'A',    'Б': 'B',    'В': 'V',    'Г': 'G',    'Д': 'D',
      'Е': 'E',    'Ё': 'E',    'Ж': 'Zh',   'З': 'Z',    'И': 'I',
      'Й': 'Y',    'К': 'K',    'Л': 'L',    'М': 'M',    'Н': 'N',
      'О': 'O',    'П': 'P',    'Р': 'R',    'С': 'S',    'Т': 'T',
      'У': 'U',    'Ф': 'F',    'Х': 'H',    'Ц': 'C',    'Ч': 'Ch',
      'Ш': 'Sh',   'Щ': 'Sch',  'Ь': '',     'Ы': 'Y',    'Ъ': '',
      'Э': 'E',    'Ю': 'Yu',   'Я': 'Ya'
    };
   
    for (var i = 0; i < text.length; ++i ) {
      if (converter[text[i]] == undefined){
        answer += text[i];
      } else {
        answer += converter[text[i]];
      }
    }
   
    return answer;
  },

  normalize(text){
    //https://stackoverflow.com/questions/11815883/convert-non-ascii-characters-umlauts-accents-to-their-closest-ascii-equiva
    var combining = /[\u0300-\u036F]/g; 
    return text.normalize('NFKD').replace(combining, '')
  },

  sid(v){    
    if (!v) return
    v = v.replace(/[^a-z0-9]/gi, '')
    v = v.toLowerCase()
    return v
  },

  nospaces(text){
    return text.replace(/ /g,'')
  },


  sanitize(html){
    let clean = DOMPurify.sanitize(html);
    return clean
  },

  // get html
  // https://marked.js.org/using_advanced
  markdown(text, options){
    if (!text) return ''
    let res = this.sanitize(
      marked(
        text
      )
    )
    return res    
  },


  // search all links and make a href
  urls(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
      return '<a href="' + url + '">' + url + '</a>';
    })
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
  },

}